// extracted by css-extract-rspack-plugin
export default {"card":"card-If0911","title":"title-BxosiP","subtitle":"subtitle-lL5bc0","body":"body-vSeXab"};